// src/features/quotation/quotationPermissions.ts
//
// Permisos de Cotizaciones. La visibilidad de cada botón la define el backend
// (tabla role_permissions); acá NO hay mapas de rol hardcodeados. Único caso de
// rol: SUPPORT es "break glass" (ve/hace todo).

export interface QuotationPermissions {
  /** Ver el detalle / entrar al historial de cotizaciones. */
  canView: boolean;
  /** Descargar el PDF de la cotización (VIEW o EXPORT, igual que el backend). */
  canPdf: boolean;
  /** Crear / guardar una cotización nueva. */
  canCreate: boolean;
  /** Editar una cotización existente (o retomar un borrador). */
  canEdit: boolean;
  /** Cancelar una cotización. */
  canCancel: boolean;
  /** Procesar la cotización (convertirla en venta). */
  canProcess: boolean;
}

/**
 * Deriva los permisos de cotización a partir del set del JWT.
 *
 * @param hasRole       ¿el usuario tiene este rol? (solo para el bypass de SUPPORT)
 * @param hasPermission ¿el usuario tiene este permiso? (del claim `permissions`)
 */
export const getQuotationPermissions = (
  hasRole: (role: string) => boolean,
  hasPermission: (permission: string) => boolean = () => false,
): QuotationPermissions => {
  const isSupport = hasRole('SUPPORT');
  const can = (permission: string) => isSupport || hasPermission(permission);

  return {
    canView: can('QUOTATIONS_VIEW'),
    canPdf: can('QUOTATIONS_VIEW') || can('QUOTATIONS_EXPORT'),
    canCreate: can('QUOTATIONS_CREATE'),
    canEdit: can('QUOTATIONS_EDIT'),
    canCancel: can('QUOTATIONS_CANCEL'),
    canProcess: can('QUOTATIONS_PROCESS'),
  };
};
